const COUNTDOWN_SELECTOR = '[data-countdown]';

/**
 * @param {HTMLElement} element
 */
function setupCountdown(element) {
  const startValue = element.dataset.countdownStart ?? '';
  const endValue = element.dataset.countdownEnd ?? '';
  const fallbackValue = element.dataset.countdownFallback ?? '';

  const startAt = startValue ? new Date(startValue).getTime() : Number.NaN;
  const endAt = endValue ? new Date(endValue).getTime() : Number.NaN;

  if (Number.isNaN(endAt)) {
    if (!fallbackValue) element.hidden = true;
    return;
  }

  const renderFallback = () => {
    element.textContent = fallbackValue;
    element.hidden = !fallbackValue;
  };

  const formatCountdown = (remainingMs) => {
    const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
    const days = Math.floor(totalSeconds / 86400);
    const hours = Math.floor((totalSeconds % 86400) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    if (days > 0) {
      return `${days}g ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
    }

    const totalHours = Math.floor(totalSeconds / 3600);
    return `${String(totalHours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
  };

  const update = () => {
    const now = Date.now();

    if (!Number.isNaN(startAt) && now < startAt) {
      renderFallback();
      return;
    }

    if (now >= endAt) {
      renderFallback();
      return;
    }

    element.hidden = false;
    element.textContent = formatCountdown(endAt - now);
  };

  update();
  window.setInterval(update, 1000);
}

document.querySelectorAll(COUNTDOWN_SELECTOR).forEach((element) => {
  if (element instanceof HTMLElement) {
    setupCountdown(element);
  }
});
